import _ from 'lodash';

export const getNumberComma = (number) => {
  let stringNumber = '-';
  if (number && !isNaN(number)) {
    stringNumber = parseInt(number)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return stringNumber;
};

// 차트 축 눈금용 - 조/억/만 단위 + 천단위 구분(비주얼 리뉴얼 2단계, 2026-10-23 §3, 재검토 2
// §6-8 경계 버그 수정). 축은 좁은 공간에 여러 눈금이 들어가므로 "1,234,000,000" 대신
// "12.3억"처럼 짧게 줄인다.
//
// 재검토 2(Fable, 2026-10-23)에서 발견된 경계 버그 3가지:
//   1) 99,999,999 -> "10000.0만" : 9999.9999를 1자리로 반올림하면 10000.0이 되는데, 이건
//      사실 1억과 같다(10000만=1억). 반올림 결과가 10000 이상이면 한 단계 위 단위로
//      다시 계산해야 한다.
//   2) 12,345,678 -> "1234.6만" : 정수부(1234)에 천단위 콤마가 없었다.
//   3) 1,000,000,000,000(1조) -> "10000억" : 조 단위가 없어서 억 단위로 끝까지 밀렸다.
// 추가로 ".0" 같은 무의미한 소수부는 떼어낸다(정수로 딱 맞게 반올림된 경우).
const COMPACT_UNIT_TIERS = [
  { value: 1e12, suffix: '조' },
  { value: 1e8, suffix: '억' },
  { value: 1e4, suffix: '만' },
];

const formatAtTier = (abs, tierIndex) => {
  const tier = COMPACT_UNIT_TIERS[tierIndex];
  const v = abs / tier.value;
  const rounded = Number.isInteger(v) ? v : Number(v.toFixed(1));
  // 반올림 결과가 10000 이상이면(예: 9999.9999만 -> 10000.0만) 한 단계 위 단위로 넘어간다 -
  // 10000만은 1억과 같으므로 "10000.0만"이 아니라 "1억"으로 보여준다.
  if (rounded >= 10000 && tierIndex > 0) {
    return formatAtTier(abs, tierIndex - 1);
  }
  const [intPart, decPart] = String(rounded).split('.');
  const intWithComma = getNumberComma(Number(intPart));
  const showDecimal = decPart && decPart !== '0';
  return `${intWithComma}${showDecimal ? `.${decPart}` : ''}${tier.suffix}`;
};

export const formatCompactKorean = (number) => {
  const n = Number(number);
  if (!n || isNaN(n)) return '0';
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(n);
  for (let i = 0; i < COMPACT_UNIT_TIERS.length; i++) {
    if (abs >= COMPACT_UNIT_TIERS[i].value) {
      return `${sign}${formatAtTier(abs, i)}`;
    }
  }
  return `${sign}${getNumberComma(abs)}`;
};

export const num2han = (num) => {
  num = parseInt((num + '').replace(/[^0-9]/g, ''), 10) + ''; // 숫자/문자/돈 을 숫자만 있는 문자열로 변환
  if (num == '0') return '영';
  var number = ['영', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  var unit = ['', '만', '억', '조'];
  var smallUnit = ['천', '백', '십', ''];
  var result = []; //변환된 값을 저장할 배열
  var unitCnt = Math.ceil(num.length / 4); //단위 갯수. 숫자 10000은 일단위와 만단위 2개이다.
  num = num.padStart(unitCnt * 4, '0'); //4자리 값이 되도록 0을 채운다
  var regexp = /[\w\W]{4}/g; //4자리 단위로 숫자 분리
  var array = num.match(regexp);
  //낮은 자릿수에서 높은 자릿수 순으로 값을 만든다(그래야 자릿수 계산이 편하다)
  for (var i = array.length - 1, unitCnt = 0; i >= 0; i--, unitCnt++) {
    var hanValue = _makeHan(array[i]); //한글로 변환된 숫자
    if (hanValue == '')
      //값이 없을땐 해당 단위의 값이 모두 0이란 뜻.
      continue;
    result.unshift(hanValue + unit[unitCnt]); //unshift는 항상 배열의 앞에 넣는다.
  }
  //여기로 들어오는 값은 무조건 네자리이다. 1234 -> 일천이백삼십사
  function _makeHan(text) {
    var str = '';
    for (var i = 0; i < text.length; i++) {
      var num = text[i];
      if (num == '0')
        //0은 읽지 않는다
        continue;
      str += number[num] + smallUnit[i];
    }
    return str;
  }
  return result.join('');
};
